import { createFileRoute } from "@tanstack/react-router";
import WhatIsTmsFamily from "@/pages/WhatIsTmsFamily";
export const Route = createFileRoute("/what-is-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "What Is TMS? A Plain Explanation for Families | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is transcranial magnetic stimulation? Learn how TMS works for depression, what it feels like, and if it may help you in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "What Is TMS? A Plain Explanation for Families | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is transcranial magnetic stimulation? Learn how TMS works for depression, what it feels like, and if it may help you in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/what-is-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsTmsFamily />;
}
